// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/save_assay_as_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssayType } from "../../../common/types/v1/assay_type_pb";
import { file_quanterix_common_types_v1_assay_type } from "../../../common/types/v1/assay_type_pb";
import type { AssayData } from "./assay_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_data } from "./assay_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/save_assay_as_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_request: GenFile = /*@__PURE__*/
  fileDesc("CkNxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvc2F2ZV9hc3NheV9hc19yZXF1ZXN0LnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEijwIKElNhdmVBc3NheUFzUmVxdWVzdBIbCg5uZXdfYXNzYXlfbmFtZRgBIAEoCUgBiAEBEkEKDm5ld19hc3NheV90eXBlGAIgASgOMiQucXVhbnRlcml4LmNvbW1vbi50eXBlcy52MS5Bc3NheVR5cGVIAogBARIXCg1mcm9tX2Fzc2F5X2lkGAMgASgJSAASSAoKYXNzYXlfZGF0YRgEIAEoCzIyLnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5Bc3NheURhdGFIAEIQCg5uZXdfYXNzYXlfZGF0YUIRCg9fbmV3X2Fzc2F5X25hbWVCEQoPX25ld19hc3NheV90eXBlYgZwcm90bzM", [file_quanterix_common_types_v1_assay_type, file_quanterix_simoa_one_analysis_app_api_v1_assay_data]);

/**
 * Rpc request to save a created or modified assay as a new assay
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsRequest
 */
export type SaveAssayAsRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsRequest"> & {
  /**
   * New user-defined assay name
   *
   * @generated from field: optional string new_assay_name = 1;
   */
  newAssayName?: string;

  /**
   * New assay type
   *
   * @generated from field: optional quanterix.common.types.v1.AssayType new_assay_type = 2;
   */
  newAssayType?: AssayType;

  /**
   * Assay data to be saved
   *
   * @generated from oneof quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsRequest.new_assay_data
   */
  newAssayData: {
    /**
     * If an id is provided, the referenced assay is duplicated and
     * saved with a new id
     *
     * @generated from field: string from_assay_id = 3;
     */
    value: string;
    case: "fromAssayId";
  } | {
    /**
     * If assay data is provided, a new assay is initialized
     *
     * @generated from field: quanterix.simoa_one.analysis_app_api.v1.AssayData assay_data = 4;
     */
    value: AssayData;
    case: "assayData";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.SaveAssayAsRequest.
 * Use `create(SaveAssayAsRequestSchema)` to create a new message.
 */
export const SaveAssayAsRequestSchema: GenMessage<SaveAssayAsRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_save_assay_as_request, 0);

